import React, { useState, useEffect } from 'react';
import api from '../services/api';
import Toast from '../components/Toast';

export default function Apar() {
  const [garduList, setGarduList] = useState([]);
  const [selectedGI, setSelectedGI] = useState('');
  const [aparList, setAparList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [toast, setToast] = useState(null);
  const [qrFormat, setQrFormat] = useState('lama'); // 'lama' = format internal app, 'url' = App Links (app + web publik)

  useEffect(() => { loadGarduList(); }, []);
  useEffect(() => { if (selectedGI) loadApar(); }, [selectedGI]);

  const loadGarduList = async () => {
    try {
      const res = await api.get('/gardu');
      setGarduList(res.data.data || []);
      if (res.data.data?.length > 0) setSelectedGI(res.data.data[0].id);
    } catch (err) { console.error(err); }
  };

  const loadApar = async () => {
    setIsLoading(true);
    try {
      const res = await api.get(`/apar/daftar/${selectedGI}`);
      setAparList(res.data.data || []);
    } catch (err) { console.error(err); }
    setIsLoading(false);
  };

  const downloadQR = async (aparId, kodeApar) => {
    try {
      const query = qrFormat === 'url' ? '?format=url' : '';
      const res = await api.get(`/qr/apar/${kodeApar}${query}`);
      const qrImage = res.data.data.qr_image;
      // Convert base64 ke file PNG
      const link = document.createElement('a');
      link.href = qrImage;
      const suffix = qrFormat === 'url' ? '_URL' : '';
      link.setAttribute('download', `QR_${kodeApar}${suffix}.png`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error(err);
      setToast({ message: 'Gagal download QR Code', type: 'error' });
    }
  };

  const downloadAllQR = async () => {
    try {
      const res = await api.get(`/qr/gi/${selectedGI}`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      const namaGI = garduList.find(g => g.id == selectedGI)?.nama || 'GI';
      link.setAttribute('download', `QR_Semua_APAR_${namaGI}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error(err);
      setToast({ message: 'Gagal download QR Code PDF', type: 'error' });
    }
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'aktif': return 'bg-green-100 text-green-700';
      case 'perlu_perhatian': return 'bg-yellow-100 text-yellow-700';
      case 'tidak_siap':
      case 'tidak_aktif':
        return 'bg-red-100 text-red-700';
      default: return 'bg-gray-100 text-gray-700';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'aktif': return 'Aman';
      case 'perlu_perhatian': return 'Waspada';
      case 'tidak_siap': return 'Kritis';
      case 'tidak_aktif': return 'Kritis (Nonaktif)';
      default: return status;
    }
  };

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Manajemen APAR</h1>
        <button onClick={downloadAllQR}
          className="bg-green-700 text-white px-4 py-2 rounded-lg hover:bg-green-600 transition-colors">
          📥 Download Semua QR PDF
        </button>
      </div>

      {/* Filter GI */}
      <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 mb-6 flex flex-wrap gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Pilih Gardu Induk</label>
          <select value={selectedGI} onChange={(e) => setSelectedGI(e.target.value)}
            className="w-full md:w-64 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
            {garduList.map(gi => <option key={gi.id} value={gi.id}>{gi.nama}</option>)}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Format QR Code</label>
          <div className="flex gap-2">
            <button onClick={() => setQrFormat('lama')}
              className={`px-3 py-2 rounded-lg text-sm font-semibold border ${qrFormat === 'lama' ? 'bg-green-700 text-white border-green-700' : 'bg-white text-gray-600 border-gray-300'}`}>
              Lama (Internal App)
            </button>
            <button onClick={() => setQrFormat('url')}
              className={`px-3 py-2 rounded-lg text-sm font-semibold border ${qrFormat === 'url' ? 'bg-green-700 text-white border-green-700' : 'bg-white text-gray-600 border-gray-300'}`}>
              Baru (URL + Publik)
            </button>
          </div>
          {qrFormat === 'url' && (
            <p className="text-xs text-amber-600 mt-1 max-w-xs">⚠ QR baru hanya berlaku untuk unit yang belum pernah dicetak. Mengganti QR unit existing berarti QR fisik lama perlu ditempel ulang.</p>
          )}
        </div>
      </div>

      {/* Statistik */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 text-center">
          <p className="text-2xl font-bold text-gray-800">{aparList.length}</p>
          <p className="text-sm text-gray-500">Total APAR</p>
        </div>
        <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 text-center">
          <p className="text-2xl font-bold text-green-600">{aparList.filter(a => a.status === 'aktif').length}</p>
          <p className="text-sm text-gray-500">Aman</p>
        </div>
        <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 text-center">
          <p className="text-2xl font-bold text-yellow-600">{aparList.filter(a => a.status === 'perlu_perhatian').length}</p>
          <p className="text-sm text-gray-500">Waspada</p>
        </div>
        <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 text-center">
          <p className="text-2xl font-bold text-red-600">{aparList.filter(a => a.status === 'tidak_siap' || a.status === 'tidak_aktif').length}</p>
          <p className="text-sm text-gray-500">Kritis</p>
        </div>
      </div>

      {/* Tabel APAR */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100">
        <div className="p-4 border-b border-gray-100">
          <h2 className="font-bold text-gray-800">Daftar Unit APAR</h2>
        </div>
        {isLoading ? (
          <div className="flex justify-center p-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-600"></div>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Kode APAR</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Jenis</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Lokasi</th>
                  <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase">Status</th>
                  <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase">QR Code</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {aparList.map((apar, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-6 py-4 font-medium text-gray-900">{apar.kode_apar}</td>
                    <td className="px-6 py-4 text-gray-600">{apar.jenis_isi} {apar.berat}</td>
                    <td className="px-6 py-4 text-gray-600">{apar.lokasi_penempatan}</td>
                    <td className="px-6 py-4 text-center">
                      <span className={`px-2 py-1 rounded-full text-xs font-bold ${getStatusBadge(apar.status)}`}>
                        {getStatusLabel(apar.status)}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-center">
                      <button onClick={() => downloadQR(apar.id, apar.kode_apar)}
                        className="text-xs bg-blue-100 text-blue-700 px-3 py-1 rounded hover:bg-blue-200">
                        📱 Download QR
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <Toast message={toast?.message} type={toast?.type} onClose={() => setToast(null)} />
    </div>
  );
}
